<div class="tsl-confirm">
    <div class="prompt-header">
        <h4 class="prompt-header-title" i18n="@@6027628753048718607" t="6027628753048718607"
            >Mismatched/Inactive Assets</h4
        >
    </div>

    <div class="prompt-content">
        <div>
            <h4 i18n="@@AssetMismatchedMessage" t="AssetMismatchedMessage"
                >The following assets have a mismatched/inactive status. Please review them or a CMT will be created for
                each asset displayed.</h4
            >
        </div>
        <div style="margin-top: 15px;">
            <div fxLayout="row" fxLayoutGap="10px" style="max-height: 400px;overflow: auto;margin-top: 25px;">
                <table tsl-table [dataSource]="assetMismatchDataSource" class="parts-table">
                    <!-- partNumber Column -->
                    <ng-container tslColumnDef="assetCode">
                        <th tsl-header-cell *tslHeaderCellDef i18n="@@Asset" t="Asset">Asset</th>
                        <td tsl-cell *tslCellDef="let element"> {{ element.assetCode }} </td>
                    </ng-container>
                    <ng-container tslColumnDef="assetStatus">
                        <th tsl-header-cell *tslHeaderCellDef i18n="@@Status" t="Status">Status</th>
                        <td tsl-cell *tslCellDef="let element"> {{ element.assetStatus }} </td>
                    </ng-container>
                    <ng-container tslColumnDef="partNumbers">
                        <th
                            tsl-header-cell
                            *tslHeaderCellDef
                            i18n="@@1925004429698263805"
                            t="1925004429698263805"
                            >PartNumber(Demand Type)</th
                        >
                        <td tsl-cell *tslCellDef="let element"> {{ element.partNumbers }} </td>
                    </ng-container>
                    <ng-container tslColumnDef="cmtType">
                        <th
                            tsl-header-cell
                            *tslHeaderCellDef
                            i18n="@@3670014620626852560"
                            t="3670014620626852560"
                            >CMT Request Type</th
                        >
                        <td tsl-cell *tslCellDef="let element"> {{ element.cmtType }} </td>
                    </ng-container>
                    <tr tsl-header-row *tslHeaderRowDef="assetErrorColumns; sticky: true"></tr>
                    <tr tsl-row *tslRowDef="let row; columns: assetErrorColumns"></tr>
                </table>
            </div>
        </div>
    </div>

    <div fxLayoutAlign="end center" class="prompt-buttons tsl-content-buttons">
        <div class="btn-group">
            <button
                tsl-button
                size="small"
                color="blue"
                filled
                (click)="onConfirm()"
                i18n="@@Confirm"
                t="Confirm"
                >Confirm</button
            >
            <button tsl-button size="small" color="black" filled (click)="onCancel()" i18n="@@Cancel" t="Cancel"
                >Cancel</button
            >
        </div>
    </div>
</div>
